export default __webpack_public_path__ + "static/media/red_rank.7befe831.png";